"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  maxLength_0: 'No more than {{count}} character. Remaining ',
  maxLength_1: 'No more than {{count}} characters. Remaining ',
  maxLength_2: 'No more than {{count}} characters. Remaining '
};